<template>
<!-- 我的客户 -->
  <div>
    <!-- 搜索区 -->
    <search-component @handleQueryData="handelSearch" @handleFilterData="handleFilter" />

    <!--客户搜索筛选框-->
    <search-pop :show.sync="showFilterPop" @handlequery="handleFqueryFilter" />
    <van-tabs v-model="active" @change="handleClick" :ellipsis="false" class="tab">
      <van-tab title="待申领" :badge="seaCount.dslCount != 0?seaCount.dslCount:''"></van-tab>
      <van-tab title="申领中" :badge="seaCount.slzCount != 0?seaCount.slzCount:''"></van-tab>
      <van-tab title="已申领" :badge="seaCount.ylsCount != 0?seaCount.ylsCount:''"></van-tab>
    </van-tabs>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" v-hasPermi="['scrm:customer:list']" @load="onLoad" v-if="list.length > 0">
    <!-- <total-component :totalValue="total" /> -->
      <van-cell v-for="(item,index) in list" :key="index">
        <div class="flex-between">
          <div style="flex: 2;">
            <div style="width:50px; height: 50px;" v-for="(item, index) in imageArr" :key="index">
              <van-image fit="cover" round  width="50px"  height="50px"  :src="item.image" />
            </div>
          </div>
          <div style="flex: 7;">
            <div class="custName-wrap" style="padding: 0;">
              <div class="custName">
                {{ item.custName }}
              </div>
            </div>
            <div>
              <div>
                <!-- <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.custType">{{ formatHandel("custType", item.custType) }}</van-tag>
                <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.custSource">{{ formatHandel("custSource", item.custSource) }}</van-tag > -->
                <!-- <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.custStatus" >{{ formatHandel("custStatus", item.custStatus) }}</van-tag> -->
                <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.custLevel">{{ formatHandel("custLevel", item.custLevel) }}</van-tag>
                <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.unitNature">{{ formatHandel("unitNature", item.unitNature) }}</van-tag >
                <!-- <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.custStatus" >{{ formatHandel("custStatus", item.custStatus) }}</van-tag> -->
                <van-tag color="#c1c1c1" style="margin-right:5px" plain v-if="item.industry" >{{ item.industry }}</van-tag>
              </div>
              <span style="color: #ccc; font-size: 12px">创建时间：{{ item.createTime | timeFormat }}</span>
            </div>
          </div>

          <!-- <div>
            <div class="custName-wrap">
              <div class="custName">
                {{ item.custName }}
              </div>
            </div>
            <div>
              <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custType">{{ formatHandel("custType",item.custType) }}</van-tag>
              <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custSource">{{ formatHandel("custSource",item.custSource) }}</van-tag>
              <van-tag color="#3d91ef" style="margin-right: 10px" plain type="primary" v-if="item.custStatus">{{ formatHandel("custStatus",item.custStatus) }}</van-tag>
            </div>
          </div> -->
          <van-button v-if="active == 0" round type="info" v-hasPermi="['scrm:apply:add']" size="mini" @click="handleApply(item)">&nbsp;&nbsp;&nbsp;申&nbsp;领&nbsp;&nbsp;&nbsp;</van-button>
          <van-button v-if="active == 1" round type="info" v-hasPermi="['scrm:apply:add']" size="mini" @click="handleAudit(item)">&nbsp;&nbsp;&nbsp;审&nbsp;核&nbsp;&nbsp;&nbsp;</van-button>
        </div>
      </van-cell>
    </van-list>
    <empty-component v-if="isEmpty" />
    <van-dialog v-model="auditOpen" title="公海客户申领审核" width="95%" class="verifyClue" :beforeClose="verifyBeforeClose" show-cancel-button>
        <van-form ref="auditForm" validate-trigger="onSubmit">
          <van-cell>该业务员本月已成功申领{{monthCount}}个客户</van-cell>
          <van-cell title="审核：" required>
            <template>
              <van-radio-group v-model="auditForm.verifyStatus" direction="horizontal">
                <van-radio name="1" clickable @click="auditForm.verifyStatus = '1'">通过</van-radio>
                <van-radio name="2" clickable @click="auditForm.verifyStatus = '2'">不通过</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field
            v-model="auditForm.content"
            rows="2"
            autosize
            label="审核原因"
            placeholder="请输入审核原因"
            type="textarea"
            show-word-limit
          />
        </van-form>
      </van-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import { addApply, getPublicCustomerList, getPublicCustomerCount, getMonthlyApplyCount, auditApply } from '@/api/scrm/mycust'
import { areaList } from '@vant/area-data'
import { getDicts } from '@/api/system/dict/data'
import SearchComponent from '@/components/common/Search'
// import TotalComponent from '@/components/common/Total'
import SearchPop from '../component/SearchPop.vue'
import EmptyComponent from '@/components/common/Empty'
import { Dialog, Toast } from 'vant'
export default {
  name: 'custClue',
  components: {
    SearchComponent,
    SearchPop,
    EmptyComponent,
    // TotalComponent,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast
  },
  data() {
    return {
      isEmpty: false,
      active: 0,
      seaCount: {},
      auditOpen: false,
      auditForm: {
        verifyStatus: '1',
        ids: []
      },
      monthCount: '',
      picker: {
        visible: false,
        visibleIndustry: false,
        title: '',
        columns: [],
        formKey: '',
        areaList
      },
      loading: false,
      finished: false,
      list: [],
      total: 0,
      show: false,
      type: 'add',
      showFilterPop: false,
      searchValue: '',
      custList: [],
      imageArr: [
        { image: require('@/assets/images/desktop/linkman2.png') }
      ],
      options: {
        // 客户类型字典
        custTypeOptions: this.$store.state.dictOptions.crmCustType || [],
        // 客户来源字典
        custSourceOptions: this.$store.state.dictOptions.custSource || [],
        // 客户状态
        custStatusOptions: this.$store.state.dictOptions.custStatus || [],

        custLevelOptions: [],
        unitNatureOptions: []
      },
      form: {
        custType: null,
        custName: null
      },
      queryParams: {
        custStatus: 0,
        pageNum: 1,
        pageSize: 10,
        isAll: 1,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    }
  },
  async created() {
    // 客户等级
    await this.getDicts('crm_cust_level').then(res => {
      this.options.custLevelOptions = res.data
    })
    // 单位性质
    await this.getDicts('crm_unit_nature').then(res => {
      this.options.unitNatureOptions = res.data
    })
    await this.handleList()
    await this.getSeaCustCount()
  },
  mounted() {
    this.init()
  },
  filters: {
    timeFormat(val) {
      return moment(val).format('YYYY-MM-DD')
    },
    timeFormat2(val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    async init() {
      document.title = '公海管理-公海客户'
    },
    QueryReset() {
      this.queryParams = {
        custStatus: 0,
        pageNum: 1,
        pageSize: 10,
        isAll: 1,
        orderByColumn: 'createTime',
        isAsc: 'desc'
      }
    },
    // 搜索子组件传递过来的搜索关键字
    handelSearch(data) {
      this.QueryReset()
      this.queryParams.custName = this.searchValue = data
      this.queryCustList()
    },
    // 过滤子组件传递过来的搜索对象
    handleFqueryFilter(data) {
      const query = this.queryParams
      this.queryParams = { ...query, ...data }
      this.queryCustList()
    },
    queryCustList() {
      this.list = []
      this.queryParams.pageNum = 1
      this.queryParams.pageSize = 10
      this.handleList()
      this.getSeaCustCount()
    },
    // 接收子组件的filter事件
    handleFilter() {
      this.showFilterPop = true
    },

    toCustBlueDetails(item) {
      this.$router.push(`/scrm/custManage/detail/${item.custId}`)
    },
    showPicker(type) {
      this.picker.formKey = type
      if (this.options.custTypeOptions.length) {
        if (type === 'custType') {
          this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
        }
      } else {
        getDicts('crm_mycust_type').then(res => {
          this.options.custTypeOptions = res.data
          if (type === 'custType') {
            this.picker.columns = this.options.custTypeOptions.map((ele) => ele.dictLabel)
          }
        })
      }
      this.picker.visible = true
    },
    addCust() {
      this.show = true
    },
    getSeaCustCount() {
      getPublicCustomerCount({ ...this.queryParams, custStatus: null }).then(res => {
        this.seaCount = res.data
      })
    },
    async handleList() {
      this.loading = true
      const res = await getPublicCustomerList(this.queryParams)
      if (res.code === 200) {
        if (res.rows.length === 0) {
          this.isEmpty = true
        } else {
          this.isEmpty = false
        }
        this.list = this.list.concat(...res.rows)
        this.total = res.total
        this.queryParams.pageNum += 1
        this.loading = false
        this.finished = this.list.length >= res.total
        this.loading = false
      }
    },
    onLoad() {
      this.handleList()
    },
    handleClick(val) {
      if (val == 0) {
        this.queryParams.custStatus = '0'
      } else if (val == 1) {
        this.queryParams.custStatus = '10'
      } else if (val == 2) {
        this.queryParams.custStatus = '11'
      }
      this.queryCustList()
    },
    handleApply(row) {
      const ids = []
      if (row.custId) {
        ids.push(row.custId)
      }
      if (ids) {
        Dialog.confirm({
          title: '申领提示',
          message: '是否确认申领？'
        })
          .then(() => {
            addApply({ ids: ids }).then(res => {
              Toast.success(res.msg)
              this.queryCustList()
            })
          })
      }
    },
    handleAudit(row) {
      getMonthlyApplyCount({ applyUserId: row.applyUserId }).then(res => {
        this.monthCount = res.data
      })
      const ids = []
      if (row.highSeasApplyId) {
        ids.push(row.highSeasApplyId)
      }
      this.auditForm.ids = ids
      this.auditOpen = true
    },
    verifyBeforeClose(type, done) {
      const that = this
      if (type === 'confirm') {
        try {
          Dialog.confirm({
            title: '审核提示',
            message: '是否确认审核？'
          }).then(function() {
            return auditApply(that.auditForm)
          }).then(() => {
            that.auditOpen = false
            Toast.success('审核成功')
            that.queryCustList()
          })
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
.tab{
  padding-top: 100px;
  margin-bottom: -100px;
}
/deep/ .van-tabs__line {
    position: absolute;
    bottom: 0.4rem;
    left: 0;
    z-index: 1;
    width: 1.06667rem;
    height: 0.08rem;
    background-color: #0a315d;
    border-radius: 0.08rem;
}
/deep/.van-info{
  background-color: #1989fa;
}
// /deep/.van-dialog{
//   height: 60%;
// }
.verifyClue /deep/.van-dialog__content {
  height: 60%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
</style>
